module.exports = __webpack_public_path__ + "6201a4678cca6812d855717d8c2a241e.svg";